import { GetOrdersOfTotemQuery } from 'data/__generated__';
import { GET_ORDERS_OF_TOTEM } from 'data/queries';
import { OrderUpdatedCacheHandlerParams } from 'types/cache.types';

export function orderUpdatedCacheHandler({
    apolloClient,
    totemId,
    orderId,
    updatedOrder,
}: OrderUpdatedCacheHandlerParams): void {
    const result = apolloClient.readQuery({
        query: GET_ORDERS_OF_TOTEM,
        variables: { totemId: totemId ?? '' },
    });
    if (!result || !result.ordersOfTotem) return;
    // const { ordersOfTotem } = result;

    // Ensure recentOrders is always an array
    const ordersOfTotem = result?.ordersOfTotem as GetOrdersOfTotemQuery['ordersOfTotem'];
    const recentOrdersRaw = ordersOfTotem?.recentOrders;
    const recentOrders = Array.isArray(recentOrdersRaw) ? recentOrdersRaw : [];
    const updatedOrders = [...recentOrders];
    const orderIds = updatedOrders?.map((localOrder) => localOrder?._id);
    const orderIndex = orderIds?.indexOf(orderId);

    updatedOrders[orderIndex] = updatedOrder as (typeof updatedOrders)[number];

    apolloClient.writeQuery({
        query: GET_ORDERS_OF_TOTEM,
        variables: { totemId: totemId ?? '' },
        data: { ordersOfTotem: { ...ordersOfTotem, recentOrders: updatedOrders } },
    });
}
